import axios from "axios";
import store from "@/store";
import i18n from "@/i18n";
import { Message } from "element-ui";
import Aes256Cryto from "@/utils/aes256Encryption";

// axios.defaults.baseURL = '/api'
axios.defaults.timeout = 1000 * 60 * 3;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    config => {
        // Use JSON content type for DEX API and AI Trader requests, form-urlencoded for others
        if (config.url && (config.url.includes('/dex-api/') || config.url.includes('/ai-trader/'))) {
            config.headers["Content-Type"] = "application/json;charset=utf-8";
        } else {
            config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=utf-8";
        }
        config.headers["language"] = i18n.locale;
        config.headers["token"] = store.state.token || '';
        config.headers["ip"] = store.state.ip || '';
        return config;
    },
    error => {
        console.log(`err${error}`);
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    res => {
        if (res.data.code === 5) {
            Message.error(`${res.data.msg}`);
            setTimeout(() => {
                store.commit('QUIT');
                store.commit('SET_IS_SHOW_LOGIN', true);
            }, 2000);
        } else if (res.data.code !== 0) {
            // For AI Trader APIs, return data with error so caller can show specific message
            if (res.config.url && res.config.url.includes('/ai-trader/')) {
                return res.data;
            }
            Message.error(`${res.data.msg}`);
            return Promise.reject(res.data.msg);
        } else {
            const type = typeof res.data.data; 
            res.data.data =type==='string'? JSON.parse(Aes256Cryto.Decrypt(res.data.data)) : res.data.data;            
            return res.data;
        }
    },
    error => {
        Message.error(`${error.message}`);
        return Promise.reject(error);
    }
)

export default axios;
